import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Suspense } from "react";
import "@/App.css";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import { SiteSettingsProvider } from "@/lib/SiteSettingsContext";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Sectors from "@/pages/Sectors";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProducts from "@/pages/AdminProducts";
import AdminCategories from "@/pages/AdminCategories";
import AdminMessages from "@/pages/AdminMessages";
import AdminAuditLogs from "@/pages/AdminAuditLogs";
import AdminPages from "@/pages/AdminPages";
import AdminSettings from "@/pages/AdminSettings";

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTop />
      <CookieBanner />
    </>
  );
}

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="sayfalar" element={<AdminPages />} />
          <Route path="urunler" element={<AdminProducts />} />
          <Route path="kategoriler" element={<AdminCategories />} />
          <Route path="mesajlar" element={<AdminMessages />} />
          <Route path="kayitlar" element={<AdminAuditLogs />} />
          <Route path="ayarlar" element={<AdminSettings />} />
        </Route>
      </Routes>
    );
  }

  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hakkimizda" element={<About />} />
        <Route path="/urunler" element={<Products />} />
        <Route path="/urun/:slug" element={<ProductDetail />} />
        <Route path="/sektorler" element={<Sectors />} />
        <Route path="/iletisim" element={<Contact />} />
      </Routes>
    </PublicLayout>
  );
}

function App() {
  return (
    <div className="App">
      <SiteSettingsProvider>
        <BrowserRouter>
          <Suspense fallback={null}>
            <Shell />
          </Suspense>
        </BrowserRouter>
      </SiteSettingsProvider>
    </div>
  );
}

export default App;
